var ContractViewModal = (function (base) {
  __extends(ContractViewModal, base);

  function ContractViewModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  };

  ContractViewModal.prototype.activate = function (contractId, deleteFunc) {
    const self = this;
    const url = 'api/contracts/' + contractId;

    this.loadContent(url)
      .then($modal => {

        $modal

          //Кнопка 'Удалить'
          .on('click', '[js=delete]', function () {
            if (confirm('Вы действительно хотите удалить этот контракт?')) {
              deleteFunc(contractId);
            }
          })

          //Кнопка 'Редактировать'
          .on('click', '[js=edit]', function () {
            ModalConductor.activate(ContractEdtiModal, contractId)
              .on('closed', (modalResult) => {
                if (modalResult.ok) {
                  self.reloadContent(url);
                }
              });
          });
      });
  };

  return ContractViewModal;
}(BaseModal));
